// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};
  
    InstantSearchResultItemProduct.prototype.prepareSuggestionProductPriceData = function() {
			var product = this.data;
			var isRoundedPrice = true;
			if (Utils.isEnableShopifyMultipleCurrencies()) {
				// Convert on FE: by rounding rules
				if (Utils.isConvertCurrenciesOnFrontEnd()) {
					product.price_min = Utils.convertPriceBasedOnActiveCurrency(product.price_min, isRoundedPrice);
					product.price_max = Utils.convertPriceBasedOnActiveCurrency(product.price_max, isRoundedPrice);
					product.compare_at_price_min = Utils.convertPriceBasedOnActiveCurrency(product.compare_at_price_min, isRoundedPrice);
					product.compare_at_price_max = Utils.convertPriceBasedOnActiveCurrency(product.compare_at_price_max, isRoundedPrice);
				// Convert on BE: by presentment price returned from API
				} else {
					Utils.convertPriceBasedOnPresentmentPrice(product);
				}
			}
	}
})();